import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  makeStyles,
  Grid,
  Button,
  colors,
  TextField,
} from "@material-ui/core";
import { ModalGeneral } from "components";
import { useForm } from "react-hook-form";

const Calificacion = ({
  setMensaje,
  datoS,
  setCargando,
  edicionEspecial,
  permisos,
  guardar,
  accion,
  tipo,
  servicios,
  ctlg,
  ...props
}) => {
  //inicializa variables

  const [mAdvertencia, setMAdvertencia] = useState({ open: false, titulo: "" });
  const { register, handleSubmit, errors, setValue, watch } = useForm();
  const cerrarAdvertencia = () => setMAdvertencia({ open: false, titulo: "" });
  const campoRequerido = {
    required: { value: true, message: "Campo requerido" },
  };
  const calf = !watch("calificacion") > 1 && !watch("calificacion") <= 100;
  useEffect(() => {
    register("idsolicitud");
    register("calificacion", {
      required: { value: true, message: "Campo requerido" },
    });
    setValue("idsolicitud", datoS.idsolicitud);
  }, []);
  return (
    <Container maxWidth={false}>
      <Container>
        <form autocomplete="off" onSubmit={handleSubmit(guardar)}>
          <Grid item lg={12} xs={12}>
            <TextField
              label="CALIFICACIÓN"
              variant="outlined"
              fullWidth
              InputProps={{ inputProps: { min: 1, max: 100 } }}
              name="calificacion"
              type="number"
              defaultValue={datoS?.calificacionEnc}
              error={errors.calificacion}
              inputRef={register(campoRequerido)}
              helperText={errors.calificacion?.message}
            />
          </Grid>
          <Grid item container justifyContent="flex-end">
            <Button
              variant="text"
              color="primary"
              type="submit"
              style={{ color: colors.green[500] }}
            >
              GUARDAR
            </Button>
          </Grid>
        </form>
      </Container>

      <ModalGeneral
        open={mAdvertencia.open}
        titulo="Advertencia"
        width="sm"
        ContenidoMensaje={mAdvertencia.mensaje}
        acciones={
          <React.Fragment>
            <Button
              className="btnError"
              color="secondary"
              onClick={cerrarAdvertencia}
            >
              CERRAR
            </Button>
            {Boolean(mAdvertencia.aceptar) && (
              <Button
                color="primary"
                style={{ color: colors.green[500] }}
                onClick={mAdvertencia.aceptar}
              >
                ACEPTAR
              </Button>
            )}
          </React.Fragment>
        }
      />
    </Container>
  );
};

export default Calificacion;
